(() => {
  if (window.spPosterFramesReady) return;
  window.spPosterFramesReady = true;
  function applyOverlays(root = document) {
    const cards = [...root.querySelectorAll('.poster-card--framed')];
    if (root.matches?.('.poster-card--framed')) cards.unshift(root);
    cards.forEach(card => {
      const media = card.querySelector('.card__media .media');
      if (!media || media.dataset.frameApplied) return;
      const overlay = document.createElement('div');
      overlay.className = 'sp-poster-frame-overlay';
      overlay.setAttribute('aria-hidden', 'true');
      media.dataset.frameApplied = '1';
      media.append(overlay);
    });
  }
  applyOverlays();
  document.addEventListener('shopify:section:load', event => applyOverlays(event.target));
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1 && (node.matches?.('.poster-card--framed') || node.querySelector?.('.poster-card--framed'))) applyOverlays(node);
    }));
  }).observe(document.body, { childList: true, subtree: true });
})();

